import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type { PaymentsApi } from '..';
import type { FindPaymentsRequestParams } from '../../model/find-payments-params';
import type { FindPaymentsResponse } from '../../model/find-payments-response';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayPaymentsApi implements PaymentsApi {
  host: string;
  client: ScpClient;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  async findPayments(
    params: FindPaymentsRequestParams
  ): Promise<FindPaymentsResponse> {
    return this.makeRequest<FindPaymentsResponse>({
      method: 'payments',
      payload: params,
    }).then((response) => response.payload);
  }

  async generateReport(
    params: FindPaymentsRequestParams
  ): Promise<{ reportId: string }> {
    return this.makeRequest<{ reportId: string }>({
      method: 'run-payments-export',
      payload: params,
    }).then((response) => response.payload);
  }

  private makeRequest<T = unknown>(
    params: Partial<RequestParams> & { method: string }
  ) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/dashboard',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
